import Branding from '../../components/Branding/Branding'

export default function AppearanceBrandingPage() {
  return <Branding />
}
